import React, {useEffect, useState} from 'react';
import './WorkTab.css';
import UniversalTable from '../UniversalTable/UniversalTable';
import {getWorkplaceUser, setConfirmInvite} from '../../api/staffApi';
import {useWebSocket} from '../../hooks/useWebSocket';
import {v4 as uuid} from 'uuid';

const WorkTab = () => {
  const [expandedOrg, setExpandedOrg] = useState(null);
  const [expandedWorkplace, setExpandedWorkplace] = useState(null);
  const [organizations, setOrganizations] = useState([]);

  const loadWorkplacesUser = async () => {
    const res = await getWorkplaceUser();
    if (Array.isArray(res.data)) {
      setOrganizations(
        res.data.map((org) => ({
          ...org,
          workplaces: org.workplaces.map((wp, i) => ({
            ...wp,
            id: uuid(),
            number: i + 1,
          })),
        }))
      );
    } else {
      setOrganizations([]);
    }
  };

  useEffect(() => {
    loadWorkplacesUser();
  }, []);

  const handleConfirmInvite = async (rowData) => {
    try {
      await setConfirmInvite({
        workplace_id: rowData.workplace_id,
        sender_id: rowData.sender_id,
      });

      // локально обновляем статус
      setOrganizations((prev) => {
        // находим индекс org, где есть нужное рабочее место
        const orgIndex = prev.findIndex((org) =>
          org.workplaces.some((wp) => wp.workplace_id === rowData.workplace_id)
        );

        // если не найдено — возвращаем прежний массив
        if (orgIndex === -1) return prev;

        // создаём новый массив с обновлённой организацией
        const newOrgs = [...prev];
        const orgToUpdate = newOrgs[orgIndex];

        newOrgs[orgIndex] = {
          ...orgToUpdate,
          workplaces: orgToUpdate.workplaces.map((wp) =>
            wp.workplace_id === rowData.workplace_id
              ? {...wp, status: 'active'}
              : wp
          ),
        };

        return newOrgs;
      });
    } catch (err) {
      console.log(err);
    }
  };

  const {messages} = useWebSocket('');

  useEffect(() => {
    if (!messages) return;

    console.log('WS message received:', messages);

    if (messages.event === 'notice_worker_add') {
      loadWorkplacesUser();
    }
  }, [messages]);

  const columnsWorkplaces = [
    {key: 'number', title: '№'},
    {key: 'department_name', title: 'Отдел'},
    {key: 'workplace_name', title: 'Рабочее место'},
    {key: 'role', title: 'Роль'},
    {
      key: 'status',
      title: 'Статус',
      type: 'statusInvite',
      awaiting: 'Ожидание',
      active: 'Активен',
      deleted: 'Удалено',
      button: {
        title: 'Подтвердить',
        onClick: async (rowData) => {
          await handleConfirmInvite(rowData);
        },
      },
    },
    {
      key: 'goTo',
      title: 'Переход',
      type: 'anyBtn',
      button: {
        title: 'Перейти',
        onClick: (rowData) => {
          console.log('Переход к рабочему месту:', rowData.workplace_name);
        },
      },
    },
  ];

  const columnsAccruals = [
    {key: 'number', title: '№ Документа'},
    {key: 'accruals', title: 'Начисления'},
    {key: 'date', title: 'Дата'},
    {key: 'withheld', title: 'Удержано'},
    {key: 'payed', title: 'Оплачено'},
  ];

  // расчет суммы всех начислений
  const totalAccruals = Array.isArray(organizations)
    ? organizations
        .flatMap((org) => org?.workplace || [])
        .flatMap((wp) => wp?.accruals || [])
        .reduce((sum, acc) => sum + (Number(acc?.accruals) || 0), 0)
    : 0;

  return (
    <section className='work-tab'>
      <div className='work-tab__container'>
        <div className='work-tab__header'>
          <h2 className='work-tab__title'>Организации</h2>
          <span className='work-tab__accruals'>
            {totalAccruals > 0
              ? `Начислено всего ${totalAccruals.toLocaleString('ru-RU')} ₽`
              : 'Нет начислений'}
          </span>
        </div>

        <ul className='work-tab__list'>
          {organizations.map((org, i) => (
            <li
              key={`${org.organisation_id}+${i}`}
              onClick={() =>
                setExpandedOrg(
                  expandedOrg === org.organisation_id
                    ? null
                    : org.organisation_id
                )
              }
              className='work-tab__item'
            >
              <div className='work-tab__subtitle'>
                <button
                  onClick={() =>
                    setExpandedOrg(
                      expandedOrg === org.organisation_id
                        ? null
                        : org.organisation_id
                    )
                  }
                  className={`work-tab__btn-more ${
                    expandedOrg === org.organisation_id ? 'expanded' : ''
                  }`}
                />
                <span>{org.name}</span>
              </div>

              {expandedOrg === org.organisation_id && (
                <div className='nested'>
                  <div className='workplaces-tab__header'>
                    <h3 className='workplaces-tab__title'>Рабочие места</h3>
                  </div>

                  <UniversalTable
                    data={(org.workplaces || []).map((wp) => {
                      const isExpanded = expandedWorkplace === wp.id;
                      return {
                        ...wp,
                        children: isExpanded ? (
                          wp.accruals?.length ? (
                            <>
                              <div className='workplaces-tab__header'>
                                <h3 className='workplaces-tab__title'>
                                  Начисления
                                </h3>
                              </div>
                              <UniversalTable
                                data={wp.accruals}
                                columns={columnsAccruals}
                                handleContextMenu={() => {}}
                                selectedItems={[]}
                                onRowClick={() => {}}
                                onSelectItem={() => {}}
                              />
                            </>
                          ) : (
                            <p style={{padding: '10px 0'}}>Нет начислений</p>
                          )
                        ) : null,
                      };
                    })}
                    columns={columnsWorkplaces}
                    handleContextMenu={() => {}}
                    selectedItems={[]}
                    expandedRow={expandedWorkplace}
                    onRowClick={(id) => {
                      console.log(id);
                      setExpandedWorkplace(
                        expandedWorkplace === id ? null : id
                      );
                    }}
                    onSelectItem={() => {}}
                    showCheckboxes={false}
                  />
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default WorkTab;
